import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND}/api`;

const api = axios.create({ baseURL: API_BASE, withCredentials: true });

export function setWorkspaceHeader(id) {
  if (id) api.defaults.headers.common["X-Workspace-Id"] = id;
  else delete api.defaults.headers.common["X-Workspace-Id"];
}

export function shortUrl(alias) {
  return `${API_BASE}/r/${alias}`;
}

export function brandedShortUrl(alias, primaryDomain) {
  return primaryDomain ? `https://${primaryDomain}/${alias}` : shortUrl(alias);
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export default api;
